import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { renderTableTitle } from "@/utils/render.jsx";
import _ from "lodash";
import { auth } from "@/service/cas";
export default {
  data() {
    const h = this.$createElement;
    return {
      showLogModal: false,
      search: {
        searchLableWidth: "80"
      },
      configLog: {
        hide: {
          search: true,
          toolBar: true
        },
        request: "",
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        map: {
          dataPath: "data.retVal.datas",
          totalPath: "data.retVal.totalRows"
        },
        table: {
          border: false
        },
        columns: [{
          title: $t("ia1k5r4", "资源名称"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "resourceDescript"
        }, {
          title: $t("dcfkxj4", "服务名称"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "serviceName"
        }, {
          title: $t("ai93a54", "修改日志"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "changeLog"
        }]
      },
      config: {
        hide: {
          search: true,
          toolBar: true
        },
        request: "/api/license/list",
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        map: {
          dataPath: "data.retVal.datas",
          totalPath: "data.retVal.totalRows"
        },
        // 续期弹窗复用 pro-table 表单，顶部标签避免多语言标签挤压输入框。
        form: {
          labelPosition: "top"
        },
        table: {
          border: false,
          height: window.innerHeight - 220
        },
        columns: [{
          title: $t("hzck2", "服务"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "descript"
        }, {
          title: $t("fl3fk3", "有效期"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "effectDate",
          align: "center"
        }, {
          title: $t("i7s72", "权益"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "limits",
          renderTable: (h, params) => {
            const {
              limits
            } = params.row;
            return _.map(limits, val => {
              return h("p", [val.typeName, " ", val.args]);
            });
          }
        }, {
          title: "resourceId",
          key: "resourceId",
          notShowTable: true,
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("hkxb2", "操作"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "action",
          isAdd: true,
          notShowSearch: true,
          notShowForm: true,
          actions: [{
            title: $t("m5le2", "续期"),
            action: async params => {
              const res = await auth(params.row.link);
              //拼接url
              if (res && res.data && res.data.result === 0) {
                window.open(res.data.retVal);
              }
              //跳转去电商商城
            }
          }, {
            title: $t("dloel44", "查看日志"),
            prevent: true,
            action: params => {
              console.log("aa");
              const resourceId = params.row.resourceId;
              this.configLog.request = "/api/license/list/authLog?resourceId=" + resourceId;
              this.showLogModal = true;
            }
          }]
        }]
      }
    };
  }
};